import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux';
import { RootState } from '../configureStore';
import { CaseEvent } from '../../data/types';

export type CaseEventState = {
    events: CaseEvent[],
}

export const useCaseEventState = () => {
    const eventState = useSelector((state: RootState | any) => state.caseEvents as CaseEventState);
    return eventState;
}

// Define the initial state using that type
const initialState: CaseEventState = {
    events: [],
}

export const caseEventSlice = createSlice({
    name: 'caseEvents',
    initialState: initialState,
    reducers: {
        setCaseEventsAction: (state, action: PayloadAction<CaseEvent[]>) => {
            state.events = action.payload;
        },
        addOrReplaceCaseEventAction: (state, action: PayloadAction<CaseEvent>) => {
            const existingIndex = state.events.findIndex((event: CaseEvent) => event?.eventId === action.payload.eventId);
            if (existingIndex >= 0) {
                state.events[existingIndex] = action.payload;
            } else {
                state.events.push(action.payload);
            }
        },
        addOrReplaceCaseEventsAction: (state, action: PayloadAction<CaseEvent[]>) => {
            action.payload.forEach((caseEvent) => {
                const existingIndex = state.events.findIndex((event: CaseEvent) => event?.eventId === caseEvent.eventId);
                if (existingIndex >= 0) {
                    state.events[existingIndex] = caseEvent;
                } else {
                    state.events.push(caseEvent);
                }
            });
        },
        deleteCaseEventAction: (state, action: PayloadAction<string>) => {
            state.events = state.events.filter((x) => x.eventId !== action.payload);
        },
        clearCaseEventsAction: (state) => {
            state.events = [];
        }
    }
})

export const { addOrReplaceCaseEventAction, addOrReplaceCaseEventsAction, setCaseEventsAction, deleteCaseEventAction, clearCaseEventsAction } = caseEventSlice.actions;

export default caseEventSlice.reducer;